import Raven from 'raven-js';
import Vue from 'vue';
import vuePlugin from 'raven-js/plugins/vue';

window.Raven = Raven;

Raven.config(window.KwIntern.sentry, {
  environment: window.KwIntern.env,
  release: window.KwIntern.release,

  user: {
    id: window.KwIntern.id,
    name: window.KwIntern.username,
    username: window.KwIntern.username,
    email: window.KwIntern.email,
  },
});

Raven.addPlugin(vuePlugin, Vue);

Raven.install();



// WEBPACK FOOTER //
// ./resources/assets/js/sentry.js